import { create } from 'zustand'

export const useModal = create((set,get) => ({
    status: false,
    type: undefined,
    headed: false,
    values: {},
    styles: {},
    loading: 'idle',
    error: undefined,
    message: '',
    open:({type, values, size, styles, headed})=>{
        set({type, values, status:true, size, styles, headed })  
    },
    toggle: ()=>{
        set({ status:!get().status })  
    },
  }))

